<template>
  <SelectTableDialog
    title="关联应付结算单"
    ref="selectTableDialog"
    :searchColumns="searchColumns"
    :columnList="columnList"
    :defaultVisible="defaultVisible"
    :API="API"
    :extraData="extraData"
    :getDataKey="'records'"
    :confirmUnchecked="false"
    :isMultiple="false"
    width="1400px"
    @close="close"
    @confirm="confirm"
    @resetBtnClick="resetBtnClick"
  >
  </SelectTableDialog>
</template>

<script>
  import SelectTableDialog from '@/components/SelectTableDialog';
  import API from '@/api/financeCenter/payment.js';
  // import DataBaseAPI from '@/api/dataBase';
  export default {
    props: {
      confirmApi: {
        // 弹窗标题
        type: String,
        default: () => '',
      },
      defaultSettlementBusinessType: {
        type: [Number, String],
        default: '',
      },
    },
    components: {
      SelectTableDialog,
    },
    data() {
      const settlementBusinessType = this.defaultSettlementBusinessType;
      console.log(settlementBusinessType, '???');
      return {
        defaultVisible: false,
        API: API.PAYABLE_SETTLEMENT_PAGE,
        extraData: {},
        billinfo: null,
      };
    },
    computed: {
      searchColumns() {
        console.log(this.defaultSettlementBusinessType, '------>>>');
        if (this.defaultSettlementBusinessType) {
          return [
            {
              prop: 'settlementCompanyName',
              name: this.$t('payablesBillList.search.payableInvoiceCompanyName'),
              type: 'input',
              disabled: true,
            },
            {
              prop: 'settlementDepartmentName',
              name: this.$t('payablesBillList.search.payableInvoiceDepartmentCode'),
              type: 'input',
              disabled: true,
            },
            {
              prop: 'settlementStatusName',
              name: this.$t('statementsList.search.slipStatus'),
              type: 'dict',
              dictType: 'slip_status',
              disabled: true,
            },
            {
              prop: 'contractNo',
              name: '合同编号',
              type: 'input',
              // type: 'searchTableSpec',
              // searchType: 'contract',
              // isMultiple: true,
              // getSearchCode: 'contractNo',
              // extraData: {
              //   contractCompanyNo: this.extraData.settlementCompanyNo,
              //   contractBusinessDepartment: this.extraData.settlementDepartmentNo,
              //   contractCategory: 'purchase',
              //   contractStatus: 'ZT03',
              //   contractDetailCategory: 'CG01',
              //   supplierNo: this.billinfo?.partnerCode,
              // },
            },
            {
              prop: 'payableSettlementNoLike',
              name: this.$t('statementsList.table.slipNo'),
              type: 'input',
            },
            {
              prop: 'supplierNo',
              name: '供应商名称',
              type: 'searchTableSpec',
              isMultiple: true,
              searchType: 'partner',
              getSearchCode: 'partnerCode',
              currentValue: this.billinfo?.payeeName,
              extraData: {
                adminFlag: this.userInfo.adminFlag,
                companyCode: this.extraData?.settlementCompanyNo,
                departmentCode: this.extraData?.settlementDepartmentNo,
                partnerTypes: 'HZHB02,HZHB03', // 客户、供应商、合作伙伴
              },
              disabled: true,
            },
          ];
        } else {
          return [
            {
              prop: 'settlementCompanyName',
              name: this.$t('payablesBillList.search.payableInvoiceCompanyName'),
              type: 'input',
              disabled: true,
            },
            {
              prop: 'settlementDepartmentName',
              name: this.$t('payablesBillList.search.payableInvoiceDepartmentCode'),
              type: 'input',
              disabled: true,
            },
            {
              prop: 'settlementStatusName',
              name: this.$t('statementsList.search.slipStatus'),
              type: 'dict',
              dictType: 'slip_status',
              disabled: true,
            },
            {
              prop: 'contractNo',
              name: '合同编号',
              type: 'searchTableSpec',
              searchType: 'contract',
              isMultiple: true,
              getSearchCode: 'contractNo',
              extraData: {
                contractCompanyNo: this.extraData.settlementCompanyNo,
                contractBusinessDepartment: this.extraData.settlementDepartmentNo,
                contractCategory: 'purchase',
                contractStatus: 'ZT03',
                contractDetailCategory: 'CG01',
                supplierNo: this.billinfo?.partnerCode,
              },
            },
            {
              prop: 'payableSettlementNoLike',
              name: this.$t('statementsList.table.slipNo'),
              type: 'input',
            },
            {
              prop: 'supplierNo',
              name: '供应商名称',
              type: 'searchTableSpec',
              isMultiple: true,
              searchType: 'partner',
              getSearchCode: 'partnerCode',
              extraData: {
                adminFlag: this.userInfo.adminFlag,
                companyCode: this.extraData?.settlementCompanyNo,
                departmentCode: this.extraData?.settlementDepartmentNo,
                partnerTypes: 'HZHB02,HZHB03', // 客户、供应商、合作伙伴
              },
            },
            {
              prop: 'settlementBusinessType',
              name: '贸易类型',
              type: 'select',
              options: this.dictListMap?.businessCategory,
            },
          ];
        }
      },
      columnList() {
        return [
          {
            prop: 'payableSettlementNo',
            label: '结算单编号',
          },
          {
            prop: 'settlementCompanyName',
            label: '公司',
          },
          {
            prop: 'settlementDepartmentName',
            label: '部门',
          },
          {
            prop: 'originalTotalAmount',
            label: '结算金额',
          },
          {
            prop: 'settlementQuantitySum',
            label: '结算数量',
          },
          {
            prop: 'paidAmount',
            label: '已付款金额',
          },
          {
            prop: 'currencyName',
            label: '币种名称',
          },
          {
            prop: 'contractNo',
            label: '合同编号',
          },
          {
            prop: 'supplierName',
            label: '供应商名称',
          },
          {
            prop: 'projectInitiationNo',
            label: '项目编码',
          },
          {
            prop: 'remark',
            label: '备注',
          },
        ];
      },
    },
    methods: {
      open(val) {
        this.defaultVisible = true;
        this.billinfo = this.$utils.clone(val, true);
        this.setInit();
      },
      setInit() {
        console.log(this.defaultSettlementBusinessType, '122233');
        this.$nextTick(() => {
          this.extraData = {
            settlementCompanyNo: this.billinfo.requestCompanyCode,
            settlementDepartmentNo: this.billinfo.requestDepartmentCode,
            settlementStatus: '04',
            isMoreDeliverer: 0,
            // isPreSettlement: 0,
            isPay: '1',
          };
          this.$refs.selectTableDialog.query.settlementCompanyNo =
            this.billinfo?.requestCompanyCode;
          this.$refs.selectTableDialog.query.settlementCompanyName =
            this.billinfo?.requestCompanyName;
          this.$refs.selectTableDialog.query.settlementDepartmentNo =
            this.billinfo?.requestDepartmentCode;
          this.$refs.selectTableDialog.query.settlementDepartmentName =
            this.billinfo?.requestDepartmentName;
          this.$refs.selectTableDialog.query.settlementStatus = this.extraData.settlementStatus;
          this.$refs.selectTableDialog.query.settlementStatusName = '已通过';
          this.$refs.selectTableDialog.query.isMoreDeliverer = 0;
          // this.$refs.selectTableDialog.query.isPreSettlement = 0;
          this.$refs.selectTableDialog.query.isPay = '1';
          this.$refs.selectTableDialog.query.settlementBusinessType = this
            .defaultSettlementBusinessType
            ? this.defaultSettlementBusinessType
            : this.billinfo?.settlementBusinessType;
          this.$refs.selectTableDialog.query.supplierNo = this.defaultSettlementBusinessType
            ? this.billinfo.payeeNo
            : '';
          this.$refs.selectTableDialog.query.supplierName = this.defaultSettlementBusinessType
            ? this.billinfo.payeeName
            : '';
        });
      },
      close() {
        this.defaultVisible = false;
        this.extraData = {};
        // ================= 清空选中 =================
        this.$refs.selectTableDialog.$refs.siruiTable.clearSelectRecord();
        // ============================================
      },
      async confirm(val) {
        console.log(val);
        if (!val[0]) {
          return this.$message({ showClose: true, message: '请选择一条应付结算单', type: 'error' });
        }
        this.$emit('updateSettle', val);
        this.close();
      },
      resetBtnClick() {
        this.setInit();
      },
    },
  };
</script>
